import React from 'react';
// import LazyLoad from 'react-lazy-load';
import PropTypes from 'prop-types';
// import WithFanAd from 'helpers/ads/WithFanAd';
import AdCaller from 'helpers/ads/adCaller';

class AdWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}
  getAdData(adData) {
    if (!this.state.refreshAd) {
      return adData;
    }
    return {
      ...adData,
      divId: `${adData.divId}-${this.state.refreshAd ? 1 : 0}`,
      slot: adData.refreshSlot,
    };
  }
  render() {
    const { adData, lazyClassName } = this.props;
    let { className } = this.props;
    const actualAdData = this.getAdData(adData);
    const isCTN =
      (actualAdData &&
        (typeof actualAdData.type !== 'undefined' &&
          actualAdData.type === 'CTN')) ||
      (actualAdData &&
        (typeof actualAdData.adType !== 'undefined' &&
          actualAdData.adType === 'ctn'));
    let msid = '';
    if (isCTN) {
      className = this.props.className;
      msid = actualAdData.msid;
    }
    // const lazyload = false;
    const dfpAd = (
      <React.Fragment>
        <AdCaller
          data={{
            divId: isCTN ? null : actualAdData.slotId,
            ...actualAdData,
            adCode:
              actualAdData.slot || actualAdData.adCode || actualAdData.slotId,
            msid,
          }}
          isCTN={isCTN}
          deviceType="mobile"
          // lazyload
          // lazyload={lazyload}
          lazyClassName={lazyClassName}
          adWapperClass={className}
          key={actualAdData.slotId}
          immediateLoad
        />
      </React.Fragment>
    );

    return dfpAd;
  }
}
AdWrapper.propTypes = {
  adData: PropTypes.shape({
    refreshSlot: PropTypes.string,
    refreshTime: PropTypes.number,
  }).isRequired,
  lazyClassName: PropTypes.string,
  className: PropTypes.string,
  // loadAllAdsAtOnce: PropTypes.bool,
  // immediateLoad: PropTypes.bool,
};
AdWrapper.defaultProps = {
  lazyClassName: undefined,
  className: undefined,
  // loadAllAdsAtOnce: undefined,
  // immediateLoad: false,
};
export default AdWrapper;
